import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Breadcrumb from '../../components/Breadcrumb';

export default function CommercialPage() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Page title
    document.title = 'Commercial Insulation Yuma AZ | Business Solutions';

    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Commercial spray foam insulation in Yuma, AZ. Reduce business energy costs 30-50%. Warehouses, offices, retail spaces. Free quotes. Call (928) 427-8140.'
      );
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + '/commercial');

    // Geo-location tags
    const metaTags = [
      { name: 'geo.region', content: 'US-AZ' },
      { name: 'geo.placename', content: 'Yuma' },
      { name: 'geo.position', content: '32.6927;-114.6277' },
      { name: 'ICBM', content: '32.6927, -114.6277' },
    ];
    metaTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Commercial Spray Foam Insulation Yuma AZ | Business Solutions' },
      {
        property: 'og:description',
        content: 'Commercial spray foam insulation in Yuma, AZ. Reduce business energy costs 30-50%. Free quotes.'
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.origin + '/commercial' },
      {
        property: 'og:image',
        content: 'https://public.readdy.ai/ai/img_res/35ebc524b1a192d4aba9e149b81a97b4.jpg'
      }
    ];
    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', tag.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Commercial Spray Foam Insulation Yuma AZ | Business Solutions' },
      {
        name: 'twitter:description',
        content: 'Commercial spray foam insulation in Yuma, AZ. Reduce business energy costs 30-50%.'
      },
      {
        name: 'twitter:image',
        content: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20warehouse%20interior%20with%20professional%20spray%20foam%20insulation%20installation%20clean%20industrial%20space%20with%20bright%20lighting%20and%20organized%20layout%20emphasizing%20energy%20efficiency%20and%20business%20productivity&width=1200&height=630&seq=twitter-commercial-001&orientation=landscape'
      }
    ];
    twitterTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Last-modified tag
    let lastModified = document.querySelector('meta[name="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('name', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    // Breadcrumb schema
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: window.location.origin + '/'
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Commercial',
          item: window.location.origin + '/commercial'
        }
      ]
    };

    let breadcrumbScript = document.querySelector('script[data-schema="breadcrumb-commercial"]');
    if (!breadcrumbScript) {
      breadcrumbScript = document.createElement('script');
      breadcrumbScript.setAttribute('type', 'application/ld+json');
      breadcrumbScript.setAttribute('data-schema', 'breadcrumb-commercial');
      document.head.appendChild(breadcrumbScript);
    }
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);

    // Service schema
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Commercial Spray Foam Insulation',
      provider: {
        '@type': 'LocalBusiness',
        name: 'Yuma Spray Foam Pros',
        telephone: '(928) 427-8140',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Yuma',
          addressRegion: 'AZ',
          addressCountry: 'US'
        }
      },
      areaServed: {
        '@type': 'City',
        name: 'Yuma',
        containedIn: {
          '@type': 'State',
          name: 'Arizona'
        }
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Commercial Insulation Services',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Warehouse Insulation'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Office Building Insulation'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Retail Space Insulation'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Industrial Facility Insulation'
            }
          }
        ]
      }
    };

    let serviceScript = document.querySelector('script[data-schema="service-commercial"]');
    if (!serviceScript) {
      serviceScript = document.createElement('script');
      serviceScript.setAttribute('type', 'application/ld+json');
      serviceScript.setAttribute('data-schema', 'service-commercial');
      document.head.appendChild(serviceScript);
    }
    serviceScript.textContent = JSON.stringify(serviceSchema);

    // LocalBusiness schema
    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Yuma Spray Foam Pros',
      telephone: '(928) 427-8140',
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 32.6927,
        longitude: -114.6277
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '127'
      }
    };

    let businessScript = document.querySelector('script[data-schema="business-commercial"]');
    if (!businessScript) {
      businessScript = document.createElement('script');
      businessScript.setAttribute('type', 'application/ld+json');
      businessScript.setAttribute('data-schema', 'business-commercial');
      document.head.appendChild(businessScript);
    }
    businessScript.textContent = JSON.stringify(localBusinessSchema);
  }, []);

  const commercialServices = [
    {
      title: "Warehouse & Distribution",
      icon: "ri-store-3-line",
      description: "Large-scale solutions for warehouses and distribution centers, dramatically reducing HVAC costs.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/486a9528472ae9a6d6e050c08f59833c.jpeg"
    },
    {
      title: "Office Buildings",
      icon: "ri-building-line",
      description: "Create comfortable, energy-efficient workspaces that improve productivity and reduce operating costs.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/c9dad4b6b52a87eedfe1a96fce7e6897.jpeg"
    },
    {
      title: "Retail Spaces",
      icon: "ri-shopping-bag-line",
      description: "Maintain consistent temperatures for customer comfort while protecting inventory and reducing energy costs.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/b76cf241ef57e7181749e4c335816dd7.jpeg"
    },
    {
      title: "Metal Buildings",
      icon: "ri-building-4-line",
      description: "Specialized application for metal structures, preventing condensation and providing superior thermal performance.",
      image: "https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/42d4837eb8665fc5e913ec7d8c6bd364.jpeg"
    }
  ];

  const industries = [
    {
      name: "Manufacturing",
      icon: "ri-settings-3-line",
      description: "Maintain precise temperature control for production processes and protect equipment."
    },
    {
      name: "Food Service",
      icon: "ri-restaurant-line",
      description: "Meet health code requirements while reducing refrigeration and HVAC costs."
    },
    {
      name: "Healthcare",
      icon: "ri-hospital-line",
      description: "Create clean, controlled environments that meet strict medical facility standards."
    },
    {
      name: "Education",
      icon: "ri-book-open-line",
      description: "Improve learning environments with better temperature control and sound reduction."
    },
    {
      name: "Hospitality",
      icon: "ri-hotel-line",
      description: "Enhance guest comfort while significantly reducing energy expenses."
    },
    {
      name: "Agriculture",
      icon: "ri-plant-line",
      description: "Protect crops and livestock with climate-controlled storage and barn facilities."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Breadcrumb
        items={[
          { label: 'Home', href: '/' },
          { label: 'Commercial' }
        ]}
      />

      {/* H1 Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Commercial Spray Foam Insulation <strong>Yuma AZ</strong>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Reduce your business <strong>energy costs by 30-50%</strong> with professional <a href="/insulation-services-arizona" className="text-blue-900 hover:text-blue-800 font-semibold underline">commercial spray foam insulation</a>. Serving warehouses, offices, retail spaces, and industrial facilities throughout Arizona.
          </p>
        </div>
      </section>

      {/* Commercial Applications */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
            Commercial Applications
          </h2>
          {/* Service Tabs */}
          <div className="flex justify-center gap-3 mb-8 flex-wrap">
            {commercialServices.map((service, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === index
                    ? 'bg-blue-900 text-white'
                    : 'bg-white text-gray-600 hover:bg-blue-50 border border-gray-200'
                }`}
              >
                <i className={`${service.icon} mr-2`}></i>
                {service.title}
              </button>
            ))}
          </div>

          {/* Active Service Display */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative h-96 w-full">
                <img 
                  src={commercialServices[activeTab].image}
                  alt={`${commercialServices[activeTab].title} Yuma AZ`}
                  title={`Professional ${commercialServices[activeTab].title}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-10 flex flex-col justify-center">
                <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6 w-fit">
                  <i className={`${commercialServices[activeTab].icon} mr-2`}></i>
                  {commercialServices[activeTab].title.toUpperCase()}
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {commercialServices[activeTab].title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                  {commercialServices[activeTab].description}
                </p>
                <a 
                  href="tel:928-427-8140" 
                  className="inline-block bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Request Project Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Served */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Industries We Serve
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Trusted by businesses across Yuma for reliable, professional service.
            </p>
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden relative">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                {industries.map((industry, index) => (
                  <div key={index} className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '280px', flexShrink: 0 }}>
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                      <i className={`${industry.icon} text-3xl text-blue-900`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{industry.name}</h3>
                    <p className="text-gray-600 leading-relaxed">
                      {industry.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-2">
              Swipe to see more →
            </div>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-3 gap-8">
            {industries.map((industry, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${industry.icon} text-3xl text-blue-900`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{industry.name}</h3>
                <p className="text-gray-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits for Business */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Business Benefits
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Smart investment that pays for itself through energy savings and improved operations.
            </p>
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden relative">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300" style={{ width: '280px', flexShrink: 0 }}>
                  <div className="text-5xl font-bold text-blue-900 mb-3">40-60%</div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Energy Cost Reduction</h3>
                  <p className="text-gray-600 text-sm">
                    Typical savings on HVAC expenses for commercial facilities
                  </p>
                </div>

                <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300" style={{ width: '280px', flexShrink: 0 }}>
                  <div className="text-5xl font-bold text-blue-900 mb-3">2-5</div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Years ROI</h3>
                  <p className="text-gray-600 text-sm">
                    Average payback period through energy savings alone
                  </p>
                </div>

                <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300" style={{ width: '280px', flexShrink: 0 }}>
                  <div className="text-5xl font-bold text-blue-900 mb-3">50+</div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Year Lifespan</h3>
                  <p className="text-gray-600 text-sm">
                    Long-lasting performance with minimal maintenance required
                  </p>
                </div>

                <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300" style={{ width: '280px', flexShrink: 0 }}>
                  <div className="text-5xl font-bold text-blue-900 mb-3">100%</div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Air Seal</h3>
                  <p className="text-gray-600 text-sm">
                    Complete barrier against air infiltration and energy loss
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-2">
              Swipe to see more →
            </div>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl font-bold text-blue-900 mb-3">40-60%</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Energy Cost Reduction</h3>
              <p className="text-gray-600 text-sm">
                Typical savings on HVAC expenses for commercial facilities
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl font-bold text-blue-900 mb-3">2-5</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Years ROI</h3>
              <p className="text-gray-600 text-sm">
                Average payback period through energy savings alone
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl font-bold text-blue-900 mb-3">50+</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Year Lifespan</h3>
              <p className="text-gray-600 text-sm">
                Long-lasting performance with minimal maintenance required
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl text-center border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl font-bold text-blue-900 mb-3">100%</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Air Seal</h3>
              <p className="text-gray-600 text-sm">
                Complete barrier against air infiltration and energy loss
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us for Commercial */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why Businesses Choose Us
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Professional service designed for commercial and industrial needs. With over 20 years of experience, we've completed hundreds of projects.
            </p>
          </div>

          {/* Mobile: Horizontal Scroll */}
          <div className="md:hidden relative">
            <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-calendar-check-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Flexible Scheduling</h3>
                  <p className="text-gray-600 leading-relaxed">
                    We work around your business hours, including nights and weekends, to minimize operational disruption.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-team-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Experienced Crews</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Our <a href="/about-yuma-insulation" className="text-blue-900 hover:text-blue-800 font-semibold underline">certified technicians</a> have completed hundreds of commercial projects, from small offices to large warehouses.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-file-list-3-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Code Compliance</h3>
                  <p className="text-gray-600 leading-relaxed">
                    All work meets or exceeds local building codes and fire safety requirements. Full documentation provided.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-shield-check-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Fully Insured</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Comprehensive liability and workers' compensation coverage protects your business and property.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-speed-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Fast Completion</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Efficient installation with large crews and professional equipment gets your facility operational quickly. We offer both <a href="/closed-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">closed-cell</a> and <a href="/open-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">open-cell foam options</a>.
                  </p>
                </div>

                <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100" style={{ width: '300px', flexShrink: 0 }}>
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-customer-service-2-line text-3xl text-blue-900"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Project Management</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Dedicated project manager coordinates with your team, contractors, and inspectors for seamless execution.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center text-sm text-gray-500 mt-2">
              Swipe to see more →
            </div>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-calendar-check-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Flexible Scheduling</h3>
              <p className="text-gray-600 leading-relaxed">
                We work around your business hours, including nights and weekends, to minimize operational disruption.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Experienced Crews</h3>
              <p className="text-gray-600 leading-relaxed">
                Our <a href="/about-yuma-insulation" className="text-blue-900 hover:text-blue-800 font-semibold underline">certified technicians</a> have completed hundreds of commercial projects, from small offices to large warehouses.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-file-list-3-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Code Compliance</h3>
              <p className="text-gray-600 leading-relaxed">
                All work meets or exceeds local building codes and fire safety requirements. Full documentation provided.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Fully Insured</h3>
              <p className="text-gray-600 leading-relaxed">
                Comprehensive liability and workers' compensation coverage protects your business and property.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-speed-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Fast Completion</h3>
              <p className="text-gray-600 leading-relaxed">
                Efficient installation with large crews and professional equipment gets your facility operational quickly. We offer both <a href="/closed-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">closed-cell</a> and <a href="/open-cell-spray-foam" className="text-blue-900 hover:text-blue-800 font-semibold underline">open-cell foam options</a>.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:bg-blue-50 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Project Management</h3>
              <p className="text-gray-600 leading-relaxed">
                Dedicated project manager coordinates with your team, contractors, and inspectors for seamless execution.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Related Services & Resources
            </h2>
            <p className="text-lg text-gray-600">
              Explore our complete range of insulation solutions
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <a 
              href="/yuma-projects" 
              className="block bg-white p-6 rounded-xl hover:bg-blue-50 transition-colors cursor-pointer group border border-gray-100"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-900 transition-colors">
                <i className="ri-image-line text-2xl text-blue-900 group-hover:text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-900">
                View Commercial Projects
              </h4>
              <p className="text-gray-600 text-sm">
                See our completed commercial work
              </p>
            </a>
            <a 
              href="/insulation-faq" 
              className="block bg-white p-6 rounded-xl hover:bg-blue-50 transition-colors cursor-pointer group border border-gray-100"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-900 transition-colors">
                <i className="ri-question-line text-2xl text-blue-900 group-hover:text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-900">
                Commercial FAQ
              </h4>
              <p className="text-gray-600 text-sm">
                Common business questions answered
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-800">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Ready to Reduce Your Operating Costs?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Get a detailed project estimate and energy savings analysis. Our commercial specialists are ready to help you plan your project.
          </p>
          <a 
            href="tel:928-427-8140" 
            className="inline-block bg-emerald-600 text-white px-4 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-emerald-700 transition-colors whitespace-normal sm:whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl max-w-full"
          >
            <i className="ri-phone-line mr-2"></i>
            Call (928) 427‑8140 for Commercial Quote
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}